var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.559 30.4826H9.86956V15.4021H14.559V30.4826ZM12.2143 13.3474C10.7087 13.3474 9.49316 12.1318 9.49316 10.6324C9.49316 9.13305 10.7087 7.91748 12.2143 7.91748C13.7137 7.91748 14.9293 9.13305 14.9293 10.6324C14.9293 12.1257 13.7137 13.3474 12.2143 13.3474ZM32.1076 30.4826H27.4243V23.1521C27.4243 21.4059 27.3934 19.1537 24.987 19.1537C22.5497 19.1537 22.1795 21.0604 22.1795 23.0287V30.4826H17.5023V15.4021H21.9943V17.4631H22.0561C22.6793 16.2783 24.2095 15.0258 26.4864 15.0258C31.2314 15.0258 32.1076 18.148 32.1076 22.2081V30.4826Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 3.5,
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkd);
export default __webpack_public_path__ + "static/media/Linkd.5554248b.svg";
export { ForwardRef as ReactComponent };